import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { feesMasterKeys } from '../feesMasterQueryKeys'
import { disableFeeDefinition } from '../feesMasterEndpoints'

export function useDisableFeeDefinitionMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => disableFeeDefinition(id),
    onSuccess: (_data, id) => {
      qc.invalidateQueries({ queryKey: feesMasterKeys.lists() })
      qc.invalidateQueries({ queryKey: feesMasterKeys.detail(id) })
    },
  })
}
